// extracted by mini-css-extract-plugin
export default {"bulkUploadHeader":"bulk-add-people_bulkUploadHeader__M4--L"};